import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/utils/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track pageview on location change
    trackPageview(location.pathname + location.search);
  }, [location]);
};
